/**
 * LoadingSpinner Component (Task 10.6)
 *
 * Reusable loading spinner with animation
 * Used for 3D model loading, scene import, and playback buffering
 */

import { motion } from 'framer-motion';

interface LoadingSpinnerProps {
  /**
   * Size of the spinner in pixels
   * @default 40
   */
  size?: number;

  /**
   * Color of the spinner
   * @default 'var(--color-body-head)'
   */
  color?: string;

  /**
   * Optional message to display below spinner
   */
  message?: string;
}

export function LoadingSpinner({
  size = 40,
  color = 'var(--color-body-head)',
  message,
}: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <motion.div
        className="rounded-full border-4 border-transparent"
        style={{
          width: size,
          height: size,
          borderTopColor: color,
          borderRightColor: color,
        }}
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: 'linear',
        }}
      />
      {message && (
        <p
          className="text-sm text-muted"
          style={{ color: 'var(--color-dark-text-muted)' }}
        >
          {message}
        </p>
      )}
    </div>
  );
}
